import React, {Component} from 'react';
import {Table, Dropdown, Button, Pagination, Icon} from 'semantic-ui-react';
import produce from 'immer';
import {PortalWithState} from 'react-portal';
import {Spring} from 'react-spring/renderprops';

import epicorApi from '../../store/services/epicor';
import {ModalWrapper} from '../modal/ModalWrapper';
import {SerialNumberDetail} from '../dashboard/SerialNumberDetail';

class PartsTable extends Component {
  state = {
    selectedResult: undefined,
    partsWithSerials: {},
    pageInfo: undefined,
    loading: false,
    activePage: 1,
  };

  _mutate = (draftFn, cb) => {
    this.setState(produce(draftFn), cb);
  };

  _fetchSerialsByPart = async partNum => {
    this._mutate(draft => {
      draft.partsWithSerials[partNum] = {
        loading: true,
      };
    });
    const result = await epicorApi.fetchSerialsByPartNum(partNum);

    this._mutate(draft => {
      draft.partsWithSerials[partNum].loading = false;
      draft.partsWithSerials[partNum].result = result;
    });
  };

  _showDetail = selectedResult => {
    this._openPortal();
    this.setState({selectedResult});
  };

  _renderDetailModal = () => {
    const {selectedResult} = this.state;

    return (
      <Spring from={{right: '-100%'}} to={{right: '0%'}}>
        {styles => (
          <ModalWrapper style={styles}>
            <SerialNumberDetail
              key={selectedResult}
              sysRowId={selectedResult}
              close={this._closePortal}
            />
          </ModalWrapper>
        )}
      </Spring>
    );
  };

  _renderRow = (part, idx) => {
    const partWithSerials = this.state.partsWithSerials[part.partNum] || {};

    const partSerialOptions = (partWithSerials.result || []).map(x => ({
      value: x.sysRowID,
      text: x.serialNumber,
    }));

    return (
      <Table.Row key={`${part.partNum}|${idx}`}>
        <Table.Cell>{part.partNum}</Table.Cell>
        <Table.Cell>
          <Dropdown
            loading={partWithSerials.loading}
            search
            selection
            noResultsMessage={
              partWithSerials.loading ? 'Loading...' : 'No serial numbers found'
            }
            onOpen={() => {
              this._fetchSerialsByPart(part.partNum);
            }}
            options={partSerialOptions}
            onChange={(_, {value}) => {
              this._mutate(draft => {
                draft.partsWithSerials[part.partNum].selected = value;
              });
            }}
            value={partWithSerials.selected}
          />
          <Button
            type="button"
            disabled={!partWithSerials.selected}
            className="clear action"
            icon
            onClick={() => {
              this._showDetail(partWithSerials.selected);
            }}
            style={{
              position: 'relative',
            }}
          >
            GO
          </Button>
        </Table.Cell>
      </Table.Row>
    );
  };

  render() {
    const {parts} = this.props;
    const {activePage} = this.state;
    const pageSize = 20;

    return (
      <PortalWithState closeOnEsc>
        {({openPortal, closePortal, portal}) => {
          this._closePortal = closePortal;
          this._openPortal = openPortal;
          return (
            <React.Fragment>
              <Table basic="very" selectable striped>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Part Number</Table.HeaderCell>
                    <Table.HeaderCell>Serial Number</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {parts
                    .slice((activePage - 1) * pageSize, activePage * pageSize)
                    .map((part, idx) => this._renderRow(part, idx))}
                </Table.Body>
              </Table>
              {portal(this._renderDetailModal())}
              <Pagination
                defaultActivePage={1}
                onPageChange={async (e, paginationInfo) => {
                  this.setState({activePage: paginationInfo.activePage});
                }}
                ellipsisItem={{
                  content: <Icon name="ellipsis horizontal" />,
                  icon: true,
                }}
                firstItem={{
                  content: <Icon name="angle double left" />,
                  icon: true,
                }}
                lastItem={{
                  content: <Icon name="angle double right" />,
                  icon: true,
                }}
                prevItem={{content: <Icon name="angle left" />, icon: true}}
                nextItem={{
                  content: <Icon name="angle right" />,
                  icon: true,
                }}
                totalPages={Math.ceil(parts.length / pageSize)}
              />
            </React.Fragment>
          );
        }}
      </PortalWithState>
    );
  }
}

export default PartsTable;
